import { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import { AuthContext } from "../context/AuthContext";
import { findClaimCompany } from "../services/helpers/AccountClaimHelpers";
import { getSearchParamNumber } from "../services/nav/QueryStringHelpers";
import { IPropertyClaims } from "../services/zeos-api/contracts/Account";

/**
 * Properties the signed-in user can see in the current company (from ?company= / ?property=),
 * resolved the same way as the dashboard page header's property breadcrumb.
 */
export const useClaimProperties = (): IPropertyClaims[] => {
  const auth = useContext(AuthContext);
  const [params] = useSearchParams();
  const companyId = getSearchParamNumber("company", params);
  const propertyId = getSearchParamNumber("property", params);
  const [properties, setProperties] = useState<IPropertyClaims[]>([]);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      const user = await auth.zeosUserAsync();
      if (cancelled) {
        return;
      }
      const company = findClaimCompany(user?.customerClaims, companyId, propertyId);
      setProperties(company?.properties ?? []);
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [auth, companyId, propertyId]);

  return properties;
};
